import React, { useEffect, useState, useRef } from 'react';
import { Menu, Dropdown, Popover } from 'antd';
import { DownOutlined, TeamOutlined, SkinOutlined, SettingOutlined, WarningFilled, AimOutlined, TrophyOutlined, RiseOutlined, LogoutOutlined, UnorderedListOutlined } from '@ant-design/icons';
import { fbDatabase } from '../../firebase/firebase';
import AdicionarVendedorFilaWrapper from './AdicionarVendedorFilaWrapper';
import { currentUser } from '../auth/auth-provider';
import "./FilaHeader.css";
import ConfiguracoesFila from './Configuracoes';

function FilaHeader(props) {
  const nomeProduto = 'Fila de Atendimento';
  const [nomeUsuario, setNomeUsuario] = useState('');
  const [labelFilaDeAtendimento, setLabelFilaDeAtendimento] = useState(nomeProduto);
  const isMounted = useRef(true);

  function handleResize() {
    if (window.innerWidth <= 400) {
      setLabelFilaDeAtendimento('Fila');
    } else {
      setLabelFilaDeAtendimento(nomeProduto);
    }
  }

  useEffect(() => {
    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      isMounted.current = false; // Marca o componente como desmontado
    };
  }, []);

  // Colocando a chamada assíncrona dentro de useEffect
  useEffect(() => {
    currentUser().then(user => {
      if (isMounted.current) {  // Apenas atualiza o estado se o componente estiver montado
        setNomeUsuario(user.nomeFantasia);
      }
    });
  }, []);

  // ── Selo "Sem meta" ─────────────────────────────────────────────────────
  // O aviso do diário só alcança quem abre o diário. Aqui ele fica no
  // cabeçalho, discreto (o tablet pode estar à vista do cliente), e explica ao
  // ser tocado. Mesma consulta do DiarioVendedor.jsx. Re-checa de tempos em
  // tempos: o tablet fica aberto por dias, e o mês vira com ele aberto.
  const [semMeta, setSemMeta] = useState(false);

  useEffect(() => {
    async function verificarMeta() {
      try {
        const loja = await currentUser();
        if (!loja?.id) return;
        const hoje = new Date();
        const snapshot = await fbDatabase
          .collection('metas')
          .where('empresaId', '==', loja.id)
          .where('ano', '==', hoje.getFullYear())
          .where('mes', '==', hoje.getMonth() + 1)
          .limit(1)
          .get();
        if (isMounted.current) setSemMeta(snapshot.empty);
      } catch (e) {
        // Sem resposta, sem selo: melhor não acusar do que acusar errado
        console.warn('Não foi possível verificar a meta do mês:', e);
      }
    }

    verificarMeta();
    const intervalo = setInterval(verificarMeta, 30 * 60 * 1000);
    return () => clearInterval(intervalo);
  }, []);

  const hoje = new Date();
  const nomeMes = hoje.toLocaleDateString('pt-BR', { month: 'long' });
  const diaDoMes = hoje.getDate();
  const diasNoMes = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0).getDate();

  // Anel do mês: quanto do mês já passou sem meta
  const RAIO = 26;
  const CIRCUNFERENCIA = 2 * Math.PI * RAIO;
  const fracaoDoMes = diaDoMes / diasNoMes;

  // A explicação fala com o TIME (o que muda no dia a dia dele), não manda
  // ninguém procurar o gerente — esse conselho é do diário, que é individual.
  // Compacta de propósito: tablet deitado tem pouca altura, e uma janela que
  // não cabe abaixo do selo é empurrada por cima dele.
  const explicacaoSemMeta = (
    <div className='ssm-pop'>
      <div className='ssm-pop-topo'>
        <div className='ssm-pop-titulo'>
          <span className='ssm-pop-rotulo'>Meta do mês</span>
          <span className='ssm-pop-mes'>{nomeMes}</span>
          <span className='ssm-pop-status'>ainda não cadastrada</span>
        </div>
        <div className='ssm-pop-anel' aria-label={`Dia ${diaDoMes} de ${diasNoMes}`}>
          <svg viewBox='0 0 64 64' width='64' height='64'>
            <circle className='ssm-pop-anel-trilho' cx='32' cy='32' r={RAIO} />
            <circle
              className='ssm-pop-anel-valor'
              cx='32'
              cy='32'
              r={RAIO}
              strokeDasharray={CIRCUNFERENCIA}
              style={{ '--ssm-offset': CIRCUNFERENCIA * (1 - fracaoDoMes), '--ssm-total': CIRCUNFERENCIA }}
            />
          </svg>
          <span className='ssm-pop-anel-texto'>
            <strong>{diaDoMes}</strong>
            <small>de {diasNoMes}</small>
          </span>
        </div>
      </div>
      <ul className='ssm-pop-lista'>
        <li>
          <span className='ssm-pop-icone'><AimOutlined /></span>
          <strong>Meta do dia</strong>
          <span>Some do diário de cada vendedor.</span>
        </li>
        <li>
          <span className='ssm-pop-icone'><TrophyOutlined /></span>
          <strong>Premiação</strong>
          <span>Sem meta, não há prêmio no mês.</span>
        </li>
        <li>
          <span className='ssm-pop-icone'><RiseOutlined /></span>
          <strong>Acumulado</strong>
          <span>As vendas de hoje ficam de fora.</span>
        </li>
      </ul>
      <p className='ssm-pop-rodape'>Assim que a meta for cadastrada, este aviso some sozinho.</p>
    </div>
  );

  const [menuAberto, setMenuAberto] = useState(false);
  const [mostrarAdicionarVendedor, setMostrarAdicionarVendedor] = useState(false);
  const [mostrarConfiguracoes, setMostrarConfiguracoes] = useState(false);

  function abrirModalAdicionarVendedor() {
    setMenuAberto(false);
    setMostrarAdicionarVendedor(true);
  }

  function selecionarSetor() {
    setMenuAberto(false);
    if (props.setSelecionarSetor) {
      props.setSelecionarSetor();
    }
  }

  function abrirModalConfiguracoes() {
    setMenuAberto(false);
    setMostrarConfiguracoes(true);
  }

  function fecharModalConfiguracoes() {
    setMostrarConfiguracoes(false);
  }

  function retornarPrimeiroAndUltimoNome(nomeCompleto) {
    const nameArray = nomeCompleto.split(' ');
    const firstName = nameArray[0];
    const lastName = nameArray[nameArray.length - 1];
    return `${firstName} ${lastName}`;
  }

  const initials = retornarPrimeiroAndUltimoNome(nomeUsuario || '')
    .split(' ')
    .map(palavra => palavra.substring(0, 1))
    .join('')
    .toUpperCase();

  const setor = props.empresaLogin?.setor;
  const cnpj = props.empresaLogin?.cnpj;

  const items = [
    { key: 'entrar', label: 'Entrar na Fila', icon: <TeamOutlined />, onClick: abrirModalAdicionarVendedor },
    { key: 'setores', label: 'Setores', icon: <UnorderedListOutlined />, onClick: selecionarSetor },
    { key: 'ordem', label: 'Ordem de Atendimento', icon: <SettingOutlined />, onClick: abrirModalConfiguracoes },
  ];

  const menu = (
    <Menu className='fh-menu-lista' selectable={false}>
      <Menu.Item key='conta' disabled className='fh-menu-conta'>
        <span className='fh-avatar fh-avatar--grande'>{initials}</span>
        <span className='fh-menu-conta-texto'>
          <strong>{nomeUsuario}</strong>
          {setor && <small>Setor {setor}</small>}
          {cnpj && <small>CNPJ {cnpj}</small>}
        </span>
      </Menu.Item>
      <Menu.Divider />
      {items.map(item => (
        <Menu.Item key={item.key} onClick={item.onClick} className='fh-menu-item'>
          <span className='fh-menu-icone'>{item.icon}</span>
          <span>{item.label}</span>
        </Menu.Item>
      ))}
      <Menu.Divider />
      <Menu.Item key='sair' onClick={() => props.setDesconectar()} className='fh-menu-item fh-menu-item--sair'>
        <span className='fh-menu-icone'><LogoutOutlined /></span>
        <span>Desconectar</span>
      </Menu.Item>
      <Menu.Item key='versao' disabled className='fh-menu-versao'>
        Versão 2.0.4
      </Menu.Item>
    </Menu>
  );

  return (
    <div className='fila-cabecalho'>
      {mostrarAdicionarVendedor && (
        <AdicionarVendedorFilaWrapper
          mostrarAdicionarVendedor={mostrarAdicionarVendedor}
          setMostrarAdicionarVendedor={setMostrarAdicionarVendedor}
          dataFila={props.dataFila}
          dataAusente={props.dataAusente}
        />
      )}

      {mostrarConfiguracoes && (
        <ConfiguracoesFila
          visible={mostrarConfiguracoes}
          dataFila={props.dataFila}
          self={props.self}
          onCancel={fecharModalConfiguracoes}
        />
      )}

      {/* Esquerda: o produto e o contexto do aparelho */}
      <div className='fh-produto'>
        <span className='fh-produto-icone'><TeamOutlined /></span>
        <span className='fh-produto-texto'>
          <span className='fh-produto-nome'>{labelFilaDeAtendimento}</span>
          {setor && <span className='fh-produto-setor'>Setor {setor}</span>}
        </span>
        {semMeta && (
          <Popover
            content={explicacaoSemMeta}
            trigger='click'
            placement='bottomLeft'
            overlayClassName='ssm-popover'
          >
            <button type='button' className='selo-sem-meta'>
              <WarningFilled />
              <span>
                Sem meta<span className='selo-sem-meta-mes'> de {nomeMes}</span>
              </span>
            </button>
          </Popover>
        )}
      </div>

      {/* Centro: a marca, no eixo exato da tela */}
      <img
        src={'https://storage.googleapis.com/bluve-bucket/logo-bluve-fila.PNG'}
        alt='Bluve'
        className='fh-logo'
      />

      {/* Direita: a conta da loja — o chip inteiro abre o menu */}
      <div className='fila-menu fh-conta-wrap'>
        <Dropdown
          overlay={menu}
          trigger={['click']}
          placement='bottomRight'
          overlayClassName='fh-menu'
          open={menuAberto}
          onOpenChange={setMenuAberto}
        >
          <button
            type='button'
            className={'fh-conta' + (menuAberto ? ' fh-conta--aberta' : '')}
            aria-haspopup='menu'
            aria-expanded={menuAberto}
          >
            <span className='fh-conta-nome'>{nomeUsuario}</span>
            <DownOutlined className='fh-conta-seta' />
            <span className='fh-avatar'>{initials}</span>
          </button>
        </Dropdown>
      </div>
    </div>
  );
}

export default FilaHeader;
